module.exports = __webpack_public_path__ + "img/icon-filter.031a3bb6.svg";